import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react"
import CartContext from "./CartContext"
import { useStaticQuery, graphql, navigate } from "gatsby"
import {
  getCart,
  getUserStoresListing,
  getUserAddressBookListing,
  processCheckOut,
  setCart,
  addToCart,
  reassignCartAddress,
  adjustQuantityInCart,
  removeItemFromCart,
  submitWebform,
  getProductListing,
  orderDigitalAsset as orderDigitalAssetCallback,
} from "../../helpers/DrupalHelper"
import StateContext from "../state/StateContext"
import { list } from "postcss"
import { verifiedHost } from "../../helpers/HostHelper"
import ModalCart from "../../components/Cart/ModalCart"
import Modal from "../../components/Modal/Modal"
import AuthenticationContext from "../authentication/AuthenticationContext"
import NotificationContext from "../Notification/NotificationContext"
import Button from "../../components/Elements/Button"
import ImageCardSmall from "../../components/Elements/ImageCardSmall"
import FloatingSelect from "../../components/Elements/Form/FloatingSelect"
import FloatingTextarea from "../../components/Elements/Form/FloatingTextarea"
import { set } from "react-hook-form"

const CART_SYNC_STORAGE_KEY = "o2o_cart_sync"
const SYNC_THROTTLE_MS = 3000

export const CartProvider = props => {
  const [cartItems, setCartItems] = useState([])
  const [prevCart, setPrevCart] = useState([])
  const [orderConfirmation, setOrderConfirmation] = useState(false)
  const [loading, setLoading] = useState(false)
  // const [userStores, setUserStores] = useState([])
  const [userAddresses, setUserAddresses] = useState([])
  const [addressLoadError, setAddressLoadError] = useState(false)
  const [addressLoading, setAddressLoading] = useState(false)
  const [emptyAddressBookModalOpen, setEmptyAddressBookModalOpen] =
    useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openCartDropdown, setOpenCartDropdown] = useState(false)
  const [assetId, setAssetId] = useState(null)
  const [products, setProducts] = useState([])
  // Cart lines dropped because their shipping address no longer exists
  // (issue #246). Surfaced on the cart page so the user can re-add them.
  const [removedCartItems, setRemovedCartItems] = useState([])
  const lastSyncRef = useRef(0)
  const { state } = useContext(StateContext)
  const { authentication } = useContext(AuthenticationContext)
  const { toggleNotification } = useContext(NotificationContext)

  // Note: Automatic quantity adjustment removed - backend validation handles limits at checkout.
  // Users can manually adjust quantities if needed.

  useEffect(() => {
    // console.log(cartItems, "cartItems")

    if (cartItems.length > 0) {
      setPrevCart(cartItems)
    }
  }, [cartItems])
  const handleProcessCart = async (
    giftOrder = false,
    orderNote = null,
    notify = null,
  ) => {
    let addressIds = new Set()
    // let addressIdsWithLessThan2Assets = new Set()

    cartItems.filter((f, k) => {
      const { addresses } = f
      addresses.map((address, s) => {
        const { address_id } = address
        addressIds.add(address_id)
      })
    })

    addressIds = Array.from(addressIds)

    // let errorArr = []
    // addressIds.map((item, k) => {
    //   let assetIdsForAddress = new Set()
    //   cartItems.filter(f => {
    //     f.addresses.filter(e => {
    //       if (e.address_id === item) {
    //         assetIdsForAddress.add(f.asset_id)
    //       }
    //     })
    //   })
    //   if (assetIdsForAddress.size < 2) errorArr.push(item)
    // })
    // console.log(
    //   errorArr
    // ) /* addressIds with less than 2 unique assets in the cart*/

    // if (errorArr.length > 0) {
    //   toggleNotification({
    //     content:
    //       "You must order at least two unique assets to each address to checkout.",
    //     error: true,
    //   })
    // } else {
    // setLoading(true)
    setPrevCart(cartItems)
    setCartItems([])
    // Optimistically empty the removed-items banner alongside the cart so it
    // stays consistent while checkout is in flight. On failure the authoritative
    // state is re-fetched below before returning the user to /cart.
    setRemovedCartItems([])
    setOrderConfirmation(null)
    processCheckOut(token, giftOrder, orderNote, notify).then(async res => {
      if ("message" in res) {
        toggleNotification({ content: res.message, error: true })
        setLoading(false)
        // Checkout failed: restore the real cart and removed-items list before
        // navigating back so the user sees their actual cart and re-add notice
        // rather than the optimistically-cleared empty state. CartProvider does
        // not re-sync on navigation, so an explicit refresh is required here.
        try {
          const value = await getCart(token, true)
          const { items, removed } = normalizeCartResponse(value)
          if (items !== null) {
            setCartItems(items)
            setRemovedCartItems(removed)
          }
        } catch (refreshError) {
          console.warn("Unable to refresh cart after failed checkout", refreshError)
        }
        navigate("/cart")
      } else {
        // let items = await getCart()
        // setCartItems([...items])
        // navigate(`/order-confirmation`, {
        //   state: { orderConfirmation: res, prevCart: prevCart },
        // })
        notifyCartChanged()
        setOrderConfirmation(res)
        setLoading(false)
        toggleNotification({
          content: `Success! Your order has been placed.`,
        })
      }
    })
    console.log({ cartItems })
    const temp_cart = cartItems.map(asset => {
      const stores = (asset.status?.stores || []).map(store => {
        const matchingAddress = (asset.addresses || []).find(
          address => address.address_id === store.id,
        )
        const maxQtyOrdered = matchingAddress
          ? parseInt(matchingAddress.quantity) + store.max_qty_ordered
          : store.max_qty_ordered
        return { ...store, max_qty_ordered: maxQtyOrdered }
      })
      return {
        ...asset,
        status: { ...asset.status, stores },
        timeStamp: Date.now(),
      }
    })
    localStorage.setItem("temp_cart", JSON.stringify(temp_cart))
    navigate(`/order-confirmation`, {
      // state: { orderConfirmation: null, prevCart: prevCart },
    })
    // }
  }
  const { token } = state
  const notifyCartChanged = () => {
    if (typeof window === "undefined") {
      return
    }

    try {
      localStorage.setItem(CART_SYNC_STORAGE_KEY, String(Date.now()))
    } catch (error) {
      console.warn("Unable to broadcast cart sync event", error)
    }
  }

  const setUserAddressBook = useCallback(userAddressesList => {
    // Guard against non-array input.
    if (!Array.isArray(userAddressesList)) {
      console.warn("setUserAddressBook received non-array:", userAddressesList)
      setUserAddresses([])
      return []
    }

    let userAddressesListSorted = userAddressesList.length
      ? userAddressesList.sort(
          (a, b) =>
            a.default === b.default
              ? 0
              : a.default
                ? -1
                : 1 /* Default item first */,
        )
      : []
    setUserAddresses(userAddressesListSorted)
    return userAddressesListSorted
  }, [])

  // Normalize the cart API response into a stable {items, removed} shape.
  // Returns items: null when the value is neither a bare array nor an
  // {items, removed} object, signalling an unusable response to the caller.
  const normalizeCartResponse = value => {
    if (Array.isArray(value)) {
      return { items: value, removed: [] }
    }
    if (value && Array.isArray(value.items)) {
      return {
        items: value.items,
        removed: Array.isArray(value.removed) ? value.removed : [],
      }
    }
    return { items: null, removed: [] }
  }

  const loadCartData = useCallback(
    async ({ suppressNotification = false } = {}) => {
      if (!authentication.currentUserData.isAuthenticated || !token) return

      try {
        // Execute cart API calls in parallel using Promise.allSettled for better isolation.
        const [cartResult, addressResult] = await Promise.allSettled([
          getCart(token, true),
          getUserAddressBookListing(token),
        ])

        // Cart can be a bare array (legacy) or {items, removed} when we opt
        // into include_removed. Normalize both shapes so existing logic keeps
        // working and we can surface removed lines (issue #246).
        let normalizedItems = null
        let normalizedRemoved = []
        if (cartResult.status === "fulfilled") {
          const { items, removed } = normalizeCartResponse(cartResult.value)
          normalizedItems = items
          normalizedRemoved = removed
        }

        // Update cart items if successful.
        if (normalizedItems !== null) {
          setCartItems(normalizedItems)
          setRemovedCartItems(normalizedRemoved)
        } else if (cartResult.status === "rejected") {
          console.error("Error loading cart:", cartResult.reason)
          setCartItems([])
          setRemovedCartItems([])
          if (!suppressNotification) {
            toggleNotification({
              content: "Unable to load your cart. Please refresh.",
              error: true,
            })
          }
        } else {
          console.warn("Cart response was not an array:", cartResult.value)
          setCartItems([])
          setRemovedCartItems([])
          if (!suppressNotification) {
            toggleNotification({
              content: "Unable to load your cart. Please refresh.",
              error: true,
            })
          }
        }

        // Update address book if successful and response is an array.
        if (
          addressResult.status === "fulfilled" &&
          Array.isArray(addressResult.value)
        ) {
          const makeAddressBook = setUserAddressBook(addressResult.value)

          // Check if address book is empty and user is approved.
          if (
            makeAddressBook.length === 0 &&
            authentication.currentUserData.status === "approved"
          ) {
            setEmptyAddressBookModalOpen(true)
          }
        } else if (
          addressResult.status === "fulfilled" &&
          addressResult.value?.error
        ) {
          // Handle authentication error from backend.
          console.warn(
            "Address book authentication error:",
            addressResult.value.error,
          )
        } else if (addressResult.status === "rejected") {
          console.error("Error loading address book:", addressResult.reason)
        }
      } catch (error) {
        console.error("Error loading cart data:", error)
      }
    },
    [
      authentication.currentUserData.isAuthenticated,
      authentication.currentUserData.status,
      setUserAddressBook,
      token,
      toggleNotification,
    ],
  )

  const syncCartItems = useCallback(async () => {
    if (!authentication.currentUserData.isAuthenticated || !token) return

    try {
      // Fetch with include_removed so the sync path surfaces lines that were
      // dropped server-side (e.g. dangling address deleted in another tab).
      const value = await getCart(token, true)
      const { items, removed } = normalizeCartResponse(value)
      if (items !== null) {
        setCartItems(items)
        // Use the server-authoritative removed list directly; reconciliation
        // is not needed here because we already have the full picture.
        setRemovedCartItems(removed)
      }
    } catch (error) {
      console.error("Error syncing cart:", error)
    }
  }, [authentication.currentUserData.isAuthenticated, token])

  useEffect(() => {
    loadCartData()
  }, [loadCartData])

  useEffect(() => {
    if (
      !authentication.currentUserData.isAuthenticated ||
      !token ||
      typeof window === "undefined"
    ) {
      return
    }

    const syncCartData = () => {
      const now = Date.now()
      if (now - lastSyncRef.current < SYNC_THROTTLE_MS) {
        return
      }

      lastSyncRef.current = now
      syncCartItems()
    }

    const handleFocus = () => {
      syncCartData()
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        syncCartData()
      }
    }

    const handleStorage = event => {
      if (event.key === CART_SYNC_STORAGE_KEY) {
        syncCartData()
      }
    }

    window.addEventListener("focus", handleFocus)
    window.addEventListener("storage", handleStorage)
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      window.removeEventListener("focus", handleFocus)
      window.removeEventListener("storage", handleStorage)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [authentication.currentUserData.isAuthenticated, syncCartItems, token])

  // Refresh addresses with retry capability - returns { success, addresses, error }.
  const refreshAddresses = async () => {
    if (!authentication.currentUserData.isAuthenticated || !token) {
      return { success: false, addresses: [], error: "not_authenticated" }
    }

    setAddressLoading(true)
    setAddressLoadError(false)

    try {
      const result = await getUserAddressBookListing(token)

      // Check for authentication error from backend.
      if (result?.error) {
        setAddressLoadError(true)
        setAddressLoading(false)
        toggleNotification({
          content:
            "Unable to load your address book. Please try logging out and back in.",
          error: true,
        })
        return { success: false, addresses: [], error: "auth_error" }
      }

      // Check for valid array response.
      if (Array.isArray(result)) {
        const sorted = setUserAddressBook(result)
        setAddressLoadError(false)
        setAddressLoading(false)
        return { success: true, addresses: sorted, error: null }
      }

      // Invalid response format.
      setAddressLoadError(true)
      setAddressLoading(false)
      toggleNotification({
        content: "Unable to load your address book. Please refresh the page.",
        error: true,
      })
      return { success: false, addresses: [], error: "invalid_response" }
    } catch (error) {
      console.error("Error refreshing addresses:", error)
      setAddressLoadError(true)
      setAddressLoading(false)
      toggleNotification({
        content:
          "Unable to load your address book. Please check your connection.",
        error: true,
      })
      return { success: false, addresses: [], error: "fetch_error" }
    }
  }

  const updateCartQuantities = async ({
    assetId: assestId,
    addresses: addressIds,
    title: title = null,
    userGroup: userGroup,
  }) => {
    let currentCartItems = [...cartItems]

    // Refresh from the server before building the payload so stale tabs work
    // with the latest cart snapshot.
    try {
      const latestCartItems = await getCart(token)
      if (Array.isArray(latestCartItems)) {
        currentCartItems = latestCartItems
      }
    } catch (error) {
      console.warn("Unable to refresh cart before update", error)
    }

    let body = [...currentCartItems]

    // Reset quantities to 0 for unchanged items.
    body = body.map(item => ({
      ...item,
      addresses: item.addresses.map(addr => ({ ...addr, quantity: "0" })),
    }))

    // Check if asset already exists in cart.
    const assetExistsInCart = body.some(
      f => parseInt(f.asset_id) === parseInt(assestId),
    )

    if (assetExistsInCart) {
      // Remove the asset from cart first.
      await removeItemFromCart(token, [
        {
          asset_id: assestId,
          addresses: [],
        },
      ])
      // Filter out the removed asset from local body instead of re-fetching.
      body = body.filter(f => parseInt(f.asset_id) !== parseInt(assestId))
    }

    // Add the new/updated asset to body.
    body = [
      ...body,
      {
        asset_id: assestId,
        addresses: addressIds,
        user_group: userGroup,
      },
    ]

    // Determine appropriate message.
    let message = `Asset ${title || assestId} added to cart successfully!`
    if (currentCartItems.some(f => f.asset_id === assestId)) {
      const existingItem = currentCartItems.find(f => f.asset_id === assestId)
      const proposedNewItem = { asset_id: assestId, addresses: addressIds }

      if (
        existingItem &&
        JSON.stringify({
          asset_id: existingItem.asset_id,
          addresses: existingItem.addresses,
        }) === JSON.stringify(proposedNewItem)
      ) {
        message = `No changes were applied to your cart for ${title || "asset " + assestId}.`
      } else {
        message = `Changes applied to your cart for ${title || "asset " + assestId}.`
      }
    }

    // Add to cart and fetch updated cart only once at the end.
    const cartResponse = await addToCart(token, body)
    const value = await getCart(token, true)
    const { items, removed } = normalizeCartResponse(value)
    if (items !== null) { setCartItems(items); setRemovedCartItems(removed) }
    notifyCartChanged()
    closeModal()

    // Check for partial success with validation errors from the backend.
    if (
      cartResponse &&
      cartResponse.status === "partial" &&
      Array.isArray(cartResponse.errors)
    ) {
      const errorMessages = cartResponse.errors.map(err => {
        const name = err.asset_title || `Asset ${err.asset_id}`
        const reasons = Array.isArray(err.reasons)
          ? err.reasons.join(", ")
          : "quantity limit exceeded"
        return `${name}: ${reasons}`
      })
      toggleNotification({
        content: `Some items could not be added: ${errorMessages.join("; ")}`,
        error: true,
      })
    } else {
      toggleNotification({
        content: message,
      })
    }
  }

  // Re-assign every asset in a cart order group from one delivery address to
  // another, preserving each asset's quantity and any other destinations it
  // ships to (#180). Mirrors updateCartQuantities' proven "remove the affected
  // assets, then re-add them while sending the rest at quantity 0" body shape,
  // so the backend keeps the remainder of the cart intact. Returns true on a
  // successful move, false on a no-op or error.
  const changeOrderAddress = async ({ fromAddressId, toAddressId, assetIds }) => {
    if (!token) return false
    if (fromAddressId == null || toAddressId == null) return false
    // No-op when the user re-selects the address the order already ships to.
    if (String(fromAddressId) === String(toAddressId)) return false

    try {
      // Operate on the freshest cart snapshot so stale tabs move the right rows
      // and an asset's full set of destinations is preserved (the structured
      // group only carries the single group address).
      let currentCartItems = [...cartItems]
      try {
        const latestCartItems = await getCart(token)
        if (Array.isArray(latestCartItems)) {
          currentCartItems = latestCartItems
        }
      } catch (error) {
        console.warn("Unable to refresh cart before address change", error)
      }

      const affectedIds = new Set(
        (assetIds || []).map(id => parseInt(id)),
      )

      // Only move assets that actually ship to the source address with a
      // positive quantity — a 0-qty source row would remove the asset without
      // re-adding it, silently deleting it from the cart.
      const itemsToMove = currentCartItems.filter(
        item =>
          affectedIds.has(parseInt(item.asset_id)) &&
          item.addresses.some(
            a =>
              String(a.address_id) === String(fromAddressId) &&
              parseInt(a.quantity) > 0,
          ),
      )

      if (itemsToMove.length === 0) return false

      // Full removal of the affected assets clears the source row even if
      // addToCart would otherwise merge into the existing address list.
      await removeItemFromCart(
        token,
        itemsToMove.map(item => ({ asset_id: item.asset_id, addresses: [] })),
      )

      const movedAssetIds = new Set(
        itemsToMove.map(item => parseInt(item.asset_id)),
      )

      // Unaffected items: send them at quantity 0 so the backend keeps them.
      let body = currentCartItems
        .filter(item => !movedAssetIds.has(parseInt(item.asset_id)))
        .map(item => ({
          ...item,
          addresses: item.addresses.map(addr => ({ ...addr, quantity: "0" })),
        }))

      // Affected items: rebuild the address list with the source destination
      // moved to the target, keeping every other destination untouched and
      // merging quantities if the asset already ships to the target.
      itemsToMove.forEach(item => {
        const sourceEntry = item.addresses.find(
          a => String(a.address_id) === String(fromAddressId),
        )
        const movedQuantity = parseInt(sourceEntry?.quantity) || 0

        const otherDestinations = item.addresses
          .filter(a => String(a.address_id) !== String(fromAddressId))
          .map(a => ({ address_id: a.address_id, quantity: a.quantity }))

        const existingTargetIndex = otherDestinations.findIndex(
          a => String(a.address_id) === String(toAddressId),
        )

        let newAddresses
        if (existingTargetIndex >= 0) {
          newAddresses = otherDestinations.map((a, idx) =>
            idx === existingTargetIndex
              ? {
                  address_id: a.address_id,
                  quantity: (parseInt(a.quantity) || 0) + movedQuantity,
                }
              : a,
          )
        } else {
          newAddresses = [
            ...otherDestinations,
            { address_id: toAddressId, quantity: movedQuantity },
          ]
        }

        body.push({
          asset_id: item.asset_id,
          addresses: newAddresses,
          ...(item.user_group ? { user_group: item.user_group } : {}),
        })
      })

      const cartResponse = await addToCart(token, body)
      const value = await getCart(token, true)
      const { items, removed } = normalizeCartResponse(value)
      if (items !== null) { setCartItems(items); setRemovedCartItems(removed) }
      notifyCartChanged()

      // Surface backend validation (e.g. per-user / max-qty limits at the new
      // address) the same way the add-to-cart flow does.
      if (
        cartResponse &&
        cartResponse.status === "partial" &&
        Array.isArray(cartResponse.errors)
      ) {
        const errorMessages = cartResponse.errors.map(err => {
          const name = err.asset_title || `Asset ${err.asset_id}`
          const reasons = Array.isArray(err.reasons)
            ? err.reasons.join(", ")
            : "quantity limit exceeded"
          return `${name}: ${reasons}`
        })
        toggleNotification({
          content: `Some items could not be moved: ${errorMessages.join("; ")}`,
          error: true,
        })
      } else {
        toggleNotification({ content: "Delivery address updated." })
      }

      return true
    } catch (error) {
      console.error("Error changing order address", error)
      // Reflect the true server state after a partial failure.
      try {
        const value = await getCart(token, true)
        const { items, removed } = normalizeCartResponse(value)
        if (items !== null) { setCartItems(items); setRemovedCartItems(removed) }
      } catch (refreshError) {
        console.warn("Unable to refresh cart after error", refreshError)
      }
      toggleNotification({
        content: "Unable to change the delivery address. Please try again.",
        error: true,
      })
      return false
    }
  }

  const openCartDropdownFunc = async (id, count, t, userGroup) => {
    let el = document.getElementsByClassName("cartDropdownButton002")[0]
    setOpenCartDropdown(!openCartDropdown)
    await updateCartQuantities({
      assetId: id,
      addresses: [{ address_id: userAddresses[0]?.id, quantity: count }],
      title: t || null,
      userGroup: userGroup,
    })
    //   id,
    //   [
    //     { address_id: userAddresses[0]?.id, quantity: count }
    //   ],
    //   t
    // )

    // assetId: assestId,
    // addresses: addressIds,
    // title: title = null,
    // userGroup: userGroup,

    el?.click()
  }

  const handleRemoveClick = async (assetId, addressId) => {
    const tempArray = [...cartItems]
    let locateAsset = tempArray.filter(
      f => parseInt(f.asset_id) === parseInt(assetId),
    )
    // alert(locateAsset)
    if (!Array.isArray(locateAsset)) {
      return false
    }
    locateAsset = locateAsset[0]

    if (
      locateAsset.addresses.length === 1 &&
      parseInt(locateAsset.addresses[0].address_id) === parseInt(addressId)
    ) {
      let body = [
        {
          asset_id: assetId,
          addresses: [],
        },
      ]
      await removeItemFromCart(token, body).then(async v => {
        const value = await getCart(token, true)
        const { items, removed } = normalizeCartResponse(value)
        if (items !== null) { setCartItems(items); setRemovedCartItems(removed) }
        notifyCartChanged()
        toggleNotification({
          content: `You removed an item from your cart.`,
        })
      })
    } else if (
      locateAsset.addresses.length > 1 &&
      locateAsset.addresses.filter(
        f => parseInt(f.address_id) === parseInt(addressId),
      ).length > 0
    ) {
      let body = [
        {
          asset_id: assetId,
          addresses: [
            {
              address_id: addressId,
            },
          ],
        },
      ]
      await removeItemFromCart(token, body).then(async v => {
        const value = await getCart(token, true)
        const { items, removed } = normalizeCartResponse(value)
        if (items !== null) { setCartItems(items); setRemovedCartItems(removed) }
        notifyCartChanged()
        toggleNotification({
          content: `You removed an item from your cart.`,
        })
      })
    } else {
      toggleNotification({
        content: `An error occured while attempting to remove this item from your cart. Please contact support.`,
        error: true,
      })
    }
  }

  const quantityUpdate = async (assetId, addressId, totalQuantity) => {
    if (totalQuantity === 0) {
      handleRemoveClick(assetId, addressId)
    } else {
      adjustQuantityInCart(token, assetId, addressId, totalQuantity).then(
        async v => {
          const value = await getCart(token, true)
          const { items, removed } = normalizeCartResponse(value)
          if (items !== null) { setCartItems(items); setRemovedCartItems(removed) }
          notifyCartChanged()
        },
      )
    }
  }

  const [cartData, setCartData] = useState({})
  const [requestedAssetData, setRequestedAssetData] = useState(null)

  const orderDigitalAsset = async ({
    assetId: asset_id,
    addresses: addresses,
    title: title,
  }) => {
    console.log(asset_id, addresses, title, "orderDigitalAsset")
    // alert('downloading')

    let res = await orderDigitalAssetCallback(
      token,
      asset_id,
      addresses.map(a => a.address_id),
    )
    if (res.ok) {
      const result = await res.text()

      if (result.includes("OK")) {
        toggleNotification({
          content: `Thanks for ordering ${title}! Your download is starting now.`,
        })
        onDownload(asset_id)
      } else {
        toggleNotification({
          content: `Downloading the latest version of ${title}`,
        })
        onDownload(asset_id)
      }
    } else {
      toggleNotification({
        content: `There was an issue processing your digital order.`,
        error: true,
      })
    }
  }

  const onDownload = async id => {
    // alert(id)
    const rand = () => Math.floor(100000000000 + Math.random() * 900000000000)
    let query = `${rand()}${id}${rand()}`
    query = btoa(query)
    const url = `${verifiedHost}/api/download?q=${query}`
    window.open(url, "_blank").focus()
  }

  const showCartModal = (assetId, data) => {
    setAssetId(assetId)
    setOpenModal(true)
    setCartData(data)

    console.log(data, "data")
    setRequestedAssetData(data.assetData)
  }
  const closeModal = () => {
    setOpenModal(false)
    setAssetId(null)
    setCartData({})
  }
  const navigateCreateAddressBookItem = () => {
    setEmptyAddressBookModalOpen(false)
    navigate("/dashboard/address-book", {
      state: { create: true },
    })
  }

  const [assetRequest, setAssetRequest] = useState(null)
  const [openRequestModal, setOpenRequestModal] = useState(false)
  // Locks the asset request submission while it is in flight. A multi-store
  // request fires one POST per store sequentially, so without this lock a
  // user clicking Submit repeatedly resends the whole batch and floods the
  // brand with duplicate requests.
  const [requestSubmitting, setRequestSubmitting] = useState(false)

  const updateRequest = (asset_id, selected_stores) => {
    setAssetRequest({
      id: asset_id,
      stores: selected_stores,
      message: "",
      products: [],
    })
    setOpenModal(false)
    setOpenRequestModal(true)
  }

  useEffect(() => {
    const loadProducts = async () => {
      if (assetRequest !== null && requestedAssetData !== null) {
        const { brand_id } = requestedAssetData

        const body = {
          brand: [brand_id],
          item_per_page: 100,
        }
        try {
          const x = await getProductListing(token, body)
          setProducts(
            x.results.map(i => Object.assign({ value: i.id, label: i.title })),
          )
        } catch (error) {
          console.error("Error loading products:", error)
        }
      }
    }

    loadProducts()
  }, [assetRequest, requestedAssetData, token])

  const closeRequestModal = () => {
    setOpenRequestModal(false)
    setAssetRequest(null)
  }

  useEffect(() => {
    if (openRequestModal === false)
      document.getElementsByTagName("html")[0].style.overflow = "visible"
  }, [openRequestModal])

  const submitAssetRequest = async () => {
    // Ignore repeat clicks while a submission is already running.
    if (requestSubmitting) {
      return
    }
    setRequestSubmitting(true)

    const uniqueStores = [
      ...new Set(assetRequest.stores.map(item => item.address_id)),
    ]

    try {
      for (const store of uniqueStores) {
        const requestStoreData = assetRequest.stores.find(
          item => item.address_id === store,
        )
        let body = {
          webform_id: "request_asset",
          delivery_locations: [requestStoreData.address_id], // Send one location at a time
          quantities: [requestStoreData.quantity], // Send the corresponding quantity
          asset: assetRequest.id,
          message: assetRequest.message,
          related_products: assetRequest.products,
          brand: requestedAssetData.brand_id,
        }

        try {
          await submitWebform(token, body)
        } catch (e) {
          toggleNotification({
            error: true,
            content: "Sorry, an error occurred.",
          })
          return // Exit loop on error
        }
      }

      setAssetRequest(null)
      setOpenRequestModal(false)
      toggleNotification({
        content:
          "Your request has been successfully submitted. Within 7 days, you will receive a notification when your request is approved or denied.",
      })
    } finally {
      // Always release the lock, even if a store submission threw above.
      setRequestSubmitting(false)
    }

    // let body = {
    //   webform_id: "request_asset",
    //   delivery_locations: assetRequest.stores.map(item => item.address_id),
    //   quantities: assetRequest.stores.map(item => item.quantity),
    //   asset: assetRequest.id,
    //   message: assetRequest.message,
    //   related_products: assetRequest.products,
    //   brand: requestedAssetData.brand_id,
    // }

    // // console.log(body, 'bod')
    // await submitWebform(token, body)
    //   .then(res => {
    //     setAssetRequest(null)
    //     setOpenRequestModal(false)
    //   })
    //   .then(res =>
    //     toggleNotification({
    //       content:
    //         "Your request has been successfully submitted. Within 7 days you will receive a notification when your request is approved or denied.",
    //     })
    //   )
    //   .catch(e =>
    //     toggleNotification({ error: true, content: "Sorry, an error occured." })
    //   )
  }
  useEffect(() => {
    const intervalId = setInterval(
      () => {
        const temp_cart = localStorage.getItem("temp_cart")
        if (!temp_cart) {
          return
        }

        const item = JSON.parse(temp_cart)
        if (!Array.isArray(item) || !item[0]?.timeStamp) {
          return
        }

        const currentTime = new Date().getTime()
        if (currentTime - item[0].timeStamp >= 5 * 60 * 1000) {
          localStorage.removeItem("temp_cart")
        }
      },
      5 * 60 * 1000,
    )

    return () => {
      clearInterval(intervalId)
    }
  }, [])
  // console.log("prevCart", prevCart)
  // console.log("orderConfirmation", orderConfirmation)
  // console.log("cartItems", cartItems)

  // Re-point a cart line to a valid shipping address after its saved address
  // was deleted (issue #248). On success, reload the cart so the repaired line
  // reappears and the removed / needs_address flags clear.
  const reassignCartLineAddress = useCallback(
    async (assetId, newAddressId, oldAddressId = null) => {
      if (!token || !assetId || !newAddressId) return { ok: false }
      const body = { asset_id: assetId, new_address_id: newAddressId }
      if (oldAddressId) body.old_address_id = oldAddressId
      const res = await reassignCartAddress(token, body)
      if (res.ok) {
        await loadCartData()
        toggleNotification({ content: "Item moved to the selected address." })
      } else {
        toggleNotification({
          content:
            res.data?.message ||
            "Could not move the item to that address. Please choose another.",
          error: true,
        })
      }
      return res
    },
    [token, loadCartData, toggleNotification],
  )

  return (
    <CartContext.Provider
      value={{
        cart: cartItems,
        removedCartItems,
        setCartItems: setCartItems,
        setRemovedCartItems: setRemovedCartItems,
        loadCartData,
        reassignCartLineAddress,
        updateCartQuantities: updateCartQuantities,
        changeOrderAddress: changeOrderAddress,
        // updateCart,
        // userStores,
        showCartModal,
        handleRemoveClick,
        quantityUpdate,
        userAddresses: userAddresses,
        addressLoadError,
        addressLoading,
        refreshAddresses,
        openCartDropdown,
        setOpenCartDropdown: openCartDropdownFunc,
        handleProcessCart: handleProcessCart,
        prevCart,
        orderConfirmation,
        setOrderConfirmation,
        setLoading,
        updateRequest,
        setUserAddressBook,
        orderDigitalAsset,
      }}
    >
      {loading ? (
        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden flex flex-col items-center justify-center">
          <div className="loader ease-linear rounded-full border-2 border-t-2 border-gray-200 h-8 w-8"></div>
          <div className="flex items-center justify-center text-xl">
            <div>
              Processing your order.
              <p className="text-reg-14">Please do not refresh this page.</p>
            </div>
          </div>
        </div>
      ) : (
        <>
          {emptyAddressBookModalOpen === true && (
            <>
              <Modal
                title="Add a Delivery Address"
                isOpen={emptyAddressBookModalOpen}
                closeModal={() =>
                  setEmptyAddressBookModalOpen(!emptyAddressBookModalOpen)
                }
              >
                <p className="text-reg-17">
                  Please add a delivery address to your Address Book. Until you
                  do, your access on O2O will remain limited.
                </p>
                <br />
                <Button
                  red
                  widthAuto
                  onClick={() => navigateCreateAddressBookItem()}
                >
                  Add an Address
                </Button>
              </Modal>
            </>
          )}
          {props.children}

          {openModal === true && (
            <ModalCart
              open={openModal}
              id={assetId}
              closeModal={closeModal}
              {...cartData}
              // byRequest={byRequest}
            />
          )}
          {openRequestModal === true && (
            <Modal
              isOpen={openRequestModal}
              closeModal={closeRequestModal}
              title={"Request Asset"}
            >
              {assetRequest !== null && (
                <>
                  <div className="flex flex-col">
                    <div className="flex items-center pb-[20px] border-b border-[#EBEBEB] mb-[20px]">
                      <ImageCardSmall image={requestedAssetData.cover[0]} />
                      <div className="ml-6 flex flex-col space-y-2">
                        <span className="text-med-10 !leading-[1]">
                          {requestedAssetData.brand_name}
                        </span>
                        <span className="!leading-[1]">
                          {requestedAssetData.title}
                        </span>
                        <span className=" !leading-[1] text-reg-14">
                          {requestedAssetData.sku}
                        </span>
                      </div>
                    </div>
                    <div className="mt-[20px]">
                      <FloatingSelect
                        isMulti
                        label="Related Products We Carry In-store"
                        name="related_products"
                        options={products}
                        description="Select any products you carry that are related to the asset you are requesting"
                        onChange={v => {
                          setAssetRequest(prevState => ({
                            ...prevState,
                            products: [...v.map(i => i.value)],
                          }))
                        }}
                      />
                      <FloatingTextarea
                        label={"Personal Message to Brand"}
                        name="message"
                        description="Type a personal message you want the brand to see."
                        onChange={v => {
                          setAssetRequest(prevState => ({
                            ...prevState,
                            message: v.target.value,
                          }))
                        }}
                      />
                    </div>
                  </div>
                  <Button
                    onClick={() => submitAssetRequest()}
                    disabled={requestSubmitting}
                  >
                    {requestSubmitting ? "Submitting…" : "Submit"}
                  </Button>
                </>
              )}
              {/* {JSON.stringify(requestedAssetData)} */}
            </Modal>
          )}
        </>
      )}
    </CartContext.Provider>
  )
}

export default CartProvider
